import { defineStore } from "pinia";
import { useBase } from "@/utils/stores/base";

const storeName = "organization";

export const useOrganizationStore = defineStore(storeName, () => {
  const { baseFetchOne } = useBase(storeName);

  const fetchOne = async (id, errorCallback) => {
    return await baseFetchOne("organizations", id, errorCallback);
  };

  return {
    fetchOne
  };
});
